import * as React from "react";
import { ModelItem, filterItemTypeMap, filterItemType } from "../../../../common";
import { SportsCarouselItem } from "../SportsCarouselItem";
import { DateCarouselItem } from "../DateCarouselItem";
import { CarouselItemProps } from "..";

const typeMap: filterItemTypeMap<(props) => JSX.Element, filterItemType> = {
    sports: (props) => (<SportsCarouselItem {...props} />),
    favorites: (props) => (<SportsCarouselItem {...props} />),
    liveStream: (props) => (<SportsCarouselItem {...props} />),
    allSports: (props) => (<SportsCarouselItem {...props} />),
    dates: (props) => (<DateCarouselItem {...props} />)
}

export const CarouselItem = (props: CarouselItemProps<ModelItem>) => {
    return typeMap[props.item.type](props);
}